"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function delay(delayMs) {
    return function (target, propertyName, descriptor) {
        if (descriptor.value != null) {
            var originalMethod_1 = descriptor.value;
            descriptor.value = function () {
                var _this = this;
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                setTimeout(function () {
                    originalMethod_1.apply(_this, args);
                }, delayMs);
            };
            return descriptor;
        }
        else {
            throw Error('@delay is applicable only on a methods.');
        }
    };
}
exports.delay = delay;
//# sourceMappingURL=../../src/dist/delay/delay.js.map